import { motion } from "framer-motion";
import { Reveal } from "@/components/primitives";

const LINES = [
  { text: "Less manual work.", grad: false },
  { text: "Better digital experiences.", grad: false },
  { text: "More room to grow.", grad: true },
];

export default function ResultSection() {
  return (
    <section className="relative overflow-hidden py-24 sm:py-32" data-testid="result-section">
      <div className="pointer-events-none absolute left-1/4 top-1/2 -z-10 h-40 w-40 -translate-y-1/2 rounded-full bg-[#FF6B35]/10 blur-3xl" />
      <div className="pointer-events-none absolute right-1/4 top-1/3 -z-10 h-48 w-48 rounded-full bg-[#2563EB]/10 blur-3xl" />

      <div className="mx-auto max-w-5xl px-4 text-center sm:px-6">
        <h2 className="font-display text-4xl font-extrabold leading-[1.08] tracking-tight text-[#111827] sm:text-5xl lg:text-6xl">
          {LINES.map((line, i) => (
            <span key={line.text} className="block overflow-hidden">
              <motion.span
                className={`inline-block ${line.grad ? "text-gradient" : ""}`}
                initial={{ y: "110%", opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true, margin: "-70px" }}
                transition={{ duration: 0.8, delay: i * 0.14, ease: [0.22, 1, 0.36, 1] }}
              >
                {line.text}
              </motion.span>
            </span>
          ))}
        </h2>
        <Reveal delay={0.5}>
          <p className="mx-auto mt-6 max-w-xl text-lg text-slate-600">
            That&apos;s the point of everything we build — websites, AI ads and automations that
            quietly do more so you can focus on what matters.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
